import { render, staticRenderFns } from "./SimilarPropertiesSlidersWrapper.vue?vue&type=template&id=3fa26cba"
import script from "./SimilarPropertiesSlidersWrapper.vue?vue&type=script&lang=js"
export * from "./SimilarPropertiesSlidersWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports